/**
 * External dependencies
 */
import queryString from "query-string";

/**
 * Internal dependencies
 */
import { Term } from "./api/types";

export const fetcher = async (url: string) => {
	return fetch(url).then((res) => res.json());
};

const queryOptions = {
	arrayFormat: "comma",
	parseNumbers: true,
	parseBooleans: true,
	skipEmptyString: true,
} as const;

export const getQueryStringValue = (
	key: string,
	requireArray = false,
	str = window.location.search
) => {
	const values = queryString.parse(str, queryOptions);

	if (!values[key]) {
		return requireArray ? [] : null;
	}

	return requireArray && !Array.isArray(values[key])
		? [values[key]]
		: values[key];
};

export const setQueryStringValue = (
	key: string,
	value: unknown,
	str = window.location.search
) => {
	const values = queryString.parse(str, queryOptions);
	const isEmptyArray = Array.isArray(value) && value.length === 0;
	const newQsValue = queryString.stringify(
		{ ...values, [key]: isEmptyArray ? "" : value },
		queryOptions
	);
	setQueryStringWithoutPageReload(newQsValue ? `?${newQsValue}` : "");
};

export const stringifyForApi = (obj: object) => {
	return queryString.stringify(obj, { arrayFormat: "bracket" });
};

export const setQueryStringWithoutPageReload = (str: string) => {
	const newurl =
		window.location.protocol +
		"//" +
		window.location.host +
		window.location.pathname +
		str;

	window.history.replaceState({ path: newurl }, "", newurl);
};

export const getArrayFromUncertainData = <T>(
	data: T[] | Record<string, T> | undefined
) => {
	return Array.isArray(data)
		? data
		: typeof data === "object"
		? Object.values(data)
		: [];
};

export const decodeSafeSpecialCharacters = (str: string) => {
	return str.replace("&amp;", "&");
};
